/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon32Regular = forwardRef('ArrowCRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10.793 4.793a1 1 0 0 1 1.414 0l8.379 8.379a4 4 0 0 1 0 5.656l-8.379 8.38a1 1 0 0 1-1.414-1.415l8.379-8.379a2 2 0 0 0 0-2.828l-8.38-8.379a1 1 0 0 1 0-1.414Z" })));
});
